import { Button, Checkbox, Image, message, Tabs } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';

import { Col, Container, Row } from 'react-bootstrap';
import BoxFinal from '../../../../assets/images/boxopenfinal.png';
import { useNavigate, useSearchParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import * as _ from 'lodash';

import { setRequestedBoxes } from '../../store/actionCreators';
import PhotoUploadModal from './PhotoUploadModal';
import BoxPhotoUpload from './BoxPhotoUpload';
import BoxContentModal from './BoxContentModal';
import { uploadInventoryPhoto } from '../../../../data/API';
import { getMyData } from '../../../../utils/token';

const Inventory = ({ inventoryList, onPhotoUploaded }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();

  const { deliveryOrder } = useSelector((state) => state.storage);
  const [selected, setSelected] = useState([]);
  const [photoUploadModalVisible, setPhotoUploadModalVisible] = useState(false);
  const [selectedInventoryForUpload, setSelectedInventoryForUpload] = useState(null);
  const [activeTab, setActiveTab] = useState(searchParams.get('subtab') || '1');
  const [boxContentModalVisible, setBoxContentModalVisible] = useState(false);
  const [selectedInventoryForContent, setSelectedInventoryForContent] = useState(null);

  useEffect(() => {
    console.log('Inventory component mounted, refreshing...');
    if (onPhotoUploaded) {
      onPhotoUploaded();
    }
  }, []);

  useEffect(() => {
    if (deliveryOrder && deliveryOrder?.requestedBoxes) {
      setSelected(deliveryOrder?.requestedBoxes?.map((item) => item?.id));
    }
  }, [deliveryOrder]);

  useEffect(() => {
    if (inventoryList.length > 0) {
      const updatedSelected = selected.filter(selectedId => {
        const box = inventoryList.find(item => item?.id == selectedId);
        return box && !box.delivery_order_id;
      });

      if (updatedSelected.length !== selected.length) {
        setSelected(updatedSelected);
      }
    }
  }, [inventoryList]);

  // Update URL when active tab changes
  const handleTabChange = (newTab) => {
    setActiveTab(newTab);
    const params = new URLSearchParams(searchParams);
    params.set('subtab', newTab);
    setSearchParams(params, { replace: true });

    if (newTab === '2' && onPhotoUploaded) {
      onPhotoUploaded();
    }
  };

  console.log('INVENTORY COMPONENT RENDERING');
  console.log('inventoryList:', inventoryList);
  console.log('inventoryList length:', inventoryList ? inventoryList.length : 'undefined');
  const handleSelect = (event) => {
    const boxId = event.target.value;
    const box = inventoryList.find(item => item?.id == boxId);

    if (box?.delivery_order_id && event.target.checked) {
      message.warning('This box is already requested for delivery');
      return;
    }

    var updatedList = [...selected];
    if (event.target.checked) {
      updatedList = [...selected, boxId];
    } else {
      updatedList.splice(selected.indexOf(boxId), 1);
    }
    setSelected(updatedList);
  };

  const handleSingleBox = (id) => {
    let selectedBoxes = inventoryList
      .filter((obj) => {
        return id == obj?.id;
      })
      .map((box) => {
        return {
          storage_inventory_id: box.id,
          box_id: box.box_id,
          box_number: box.storageBox.box_number
        };
      });

    if (selectedBoxes?.length) {
      dispatch(setRequestedBoxes(selectedBoxes));
      navigate('/storage-box/my-account/request-delivery');
    } else {
      message.error('Please select at least one box');
    }
  };

  const handleSubmitBoxes = async () => {
    let selectedBoxes = inventoryList
      .filter((obj) => {
        return selected.some((box) => box == obj?.id) && !obj.delivery_order_id;
      })
      .map((box) => {
        return {
          storage_inventory_id: box.id,
          box_id: box.box_id,
          box_number: box.storageBox.box_number
        };
      });

    if (selectedBoxes?.length) {
      dispatch(setRequestedBoxes(selectedBoxes));
      navigate('/storage-box/my-account/request-delivery');
    } else {
      message.error('Please select at least one available box for delivery');
    }
  };

  const handleOpenPhotoUpload = (item) => {
    setSelectedInventoryForUpload(item);
    setPhotoUploadModalVisible(true);
  };

  const handlePhotoUpload = async (inventoryId, imageFile) => {
    try {
      const userData = getMyData();
      const userEmail = userData?.email;

      if (!userEmail) {
        throw new Error('User email not found. Please log in again.');
      }

      const response = await uploadInventoryPhoto(inventoryId, imageFile, userEmail);

      if (response.data && response.data.success) {
        message.success('Photo uploaded successfully!');
        await new Promise(resolve => setTimeout(resolve, 500));

        if (onPhotoUploaded) {
          onPhotoUploaded();
        }

        return response.data;
      } else {
        throw new Error(response.data?.message || 'Upload failed');
      }
    } catch (error) {
      console.error('Photo upload error:', error);
      throw new Error(
        error.response?.data?.message ||
        error.message ||
        'Failed to upload photo. Please try again.'
      );
    }
  };

  const handlePhotoUploadSuccess = () => {
    if (onPhotoUploaded) {
      onPhotoUploaded();
    }
    handleTabChange('2');
  };

  const handleOpenBoxContent = (item) => {
    setSelectedInventoryForContent(item);
    setBoxContentModalVisible(true);
  };

  const handleBoxContentClose = () => {
    setBoxContentModalVisible(false);
    setSelectedInventoryForContent(null);
  };

  const tabItems = [
    {
      key: '1',
      label: 'Upload Box Photos',
      children: <BoxPhotoUpload onPhotoUploaded={handlePhotoUploadSuccess} />,
    },
    {
      key: '2',
      label: `My Inventory (${inventoryList.length})`,
      children: (
        inventoryList.length === 0 ? (
          <div className="text-center py-5">
            <p className="text-muted">No inventory items yet. Upload box photos to get started!</p>
          </div>
        ) : (
          <Checkbox.Group style={{ width: '100%' }}>
            <Container>
              <Row className="align-items-center justify-content-start inv-list">
                {inventoryList.map((item, index) => {
              return (
                <Col
                  xxl={3}
                  xl={6}
                  lg={5}
                  md={6}
                  sm={8}
                  xs={12}
                  // className="p-0"
                  key={`inventory_box_${index + 1}`}>
                  <div className="inventory-card p-3 mb-3">
                    <div className="d-flex align-items-center justify-content-end inv-select-box">
                      {item.delivery_order_id ? (
                        <p className="mb-0 px-2 color-gray inv-checkbox" style={{ opacity: 0.5 }}>In Delivery</p>
                      ) : selected.some((box) => box == item?.id) ? (
                        <p className="mb-0 px-2 color-secondary inv-checkbox">Selected</p>
                      ) : (
                        <p className="mb-0 px-2 color-gray inv-checkbox">Select</p>
                      )}
                      <Checkbox value={item?.id} onChange={handleSelect} disabled={item.delivery_order_id}></Checkbox>
                    </div>

                    <div className="d-flex justify-content-start align-items-center inventory-card-container">
                      <div className="inventory-img">
                        <Image
                          src={item.content_image ? item.content_image : BoxFinal}
                          preview={false}
                          className="inv-img"
                          alt="inventory_preview"
                        />
                      </div>
                      <div className="inventory-content ml-3">
                        <div className="w-100">
                          <p className="mb-1 inv-box-head fw-600">
                            Box Number {item.storageBox?.box_number}
                          </p>
                          {item.order_number && (
                            <p className="mb-2 text-muted small">
                              Order: {item.order_number}
                            </p>
                          )}
                          <Button
                            onClick={() => handleOpenBoxContent(item)}
                            type="primary"
                            size="large"
                            className="inventory-btn mb-2 fw-600 w-100"
                            ghost
                            block>
                            Box content
                          </Button>

                          <Button
                            onClick={() => handleOpenPhotoUpload(item)}
                            type="default"
                            size="large"
                            className="inventory-btn mb-2 fw-600 w-100"
                            block>
                            Upload Photo
                          </Button>

                          {item.delivery_order_id ? (
                            <Button
                              disabled = 'true'
                              // onClick={() => handleSingleBox(item?.id)}
                              type="primary"
                              size="large"
                              className="inventory-req fw-600 w-100 bg-theme-secondary opacity05"
                              block>
                              Requested to {item.delivery_order_date ? moment(item.delivery_order_date).format('DD.MM.YYYY') : 'TBD'}
                            </Button>
                          ) : (
                            <Button
                              onClick={() => handleSingleBox(item?.id)}
                              type="primary"
                              size="large"
                              className="inventory-req fw-600 w-100 bg-theme-secondary"
                              block>
                              Request Delivery
                            </Button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              );
            })}
          </Row>
          {(() => {
            const hasAvailableSelected = selected.length > 0 &&
              inventoryList.some(item => selected.includes(item?.id) && !item.delivery_order_id);

            console.log('🔍 Request Selected button visibility:', {
              selectedCount: selected.length,
              hasAvailableSelected,
              selectedBoxDetails: inventoryList
                .filter(item => selected.includes(item?.id))
                .map(item => ({
                  id: item.id,
                  box_number: item.storageBox?.box_number,
                  delivery_order_id: item.delivery_order_id
                }))
            });

            return hasAvailableSelected && (
              <Row>
                <Col className="request-sel">
                  <Button
                    type="primary"
                    size="large"
                    className="fw-600 more-btn justify-content-end"
                    onClick={handleSubmitBoxes}>
                    Request Selected
                  </Button>
                </Col>
              </Row>
            );
          })()}
        </Container>
      </Checkbox.Group>
        )
      ),
    },
  ];

  return (
    <div className="user-inventory py-3 px-3 s-color-black">
      <Tabs
        activeKey={activeTab}
        onChange={handleTabChange}
        items={tabItems}
        centered
        style={{ '--tab-gap': '80px' }}
        className="inventory-tabs-centered"
      />

      <PhotoUploadModal
        visible={photoUploadModalVisible}
        onClose={() => setPhotoUploadModalVisible(false)}
        onUpload={handlePhotoUpload}
        boxNumber={selectedInventoryForUpload?.storageBox?.box_number || ''}
        inventoryId={selectedInventoryForUpload?.id || 0}
      />

      <BoxContentModal
        visible={boxContentModalVisible}
        onClose={handleBoxContentClose}
        boxNumber={selectedInventoryForContent?.storageBox?.box_number || ''}
        inventoryId={selectedInventoryForContent?.id || 0}
      />
    </div>
  );
};

export default Inventory;

Inventory.propTypes = {
  inventoryList: PropTypes.any,
  onPhotoUploaded: PropTypes.func
};
